import React from 'react';
import PropTypes from 'prop-types';

class Tabs extends React.Component {
  static Tab = ({ children }) => <div>{children}</div>;

  state = {
    activeIndex: this.props.defaultIndex || 0
  };

  render() {
    const { activeIndex } = this.state;
    const tabs = React.Children.map(this.props.children, (child, index) => {
      const activeStyle = index === activeIndex ? 'active' : '';
      const customListStyle = index % 2 === 0 ? 'li-become' : 'li-partner';
      const customLinkStyle = index % 2 === 0 ? 'become' : 'partner';
      return (
        <li className={`${customListStyle} ${activeStyle}`}>
          <a
            tabIndex="-1"
            role="button"
            className={customLinkStyle}
            onClick={() => this.setState({ activeIndex: index })}
          >
            {child.props.label}
          </a>
        </li>
      );
    });
    return (
      <div>
        <ul className="options">{tabs}</ul>
        {this.props.children[this.state.activeIndex]}
      </div>
    );
  }
}

Tabs.defaultProps = {
  defaultIndex: 0
};

Tabs.propTypes = {
  defaultIndex: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
    PropTypes.number,
    PropTypes.func,
    PropTypes.array
  ]).isRequired
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/pages/partners/components/Tabs/Tabs.js